import * as React from 'react';
import {withNavigation} from '../navigation/navigation';
import {Breadcrumbs, Stack, Typography} from '@mui/material';
import ViewProfile from './ViewProfile';
import UpdateProfile from './UpdateProfile';
import {useState} from 'react';
import ViewPassword from './ViewPassword';
import ChangePassword from './ChangePassword';
import Associate from './Associate';
import NotificationConfig from './NotificationConfig';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useNavigate} from 'react-router-dom';
import {useUserSubscription} from '../subscription/hook/useUserSubscription';

const Profile = ({setShowNav}) => {
  setShowNav(false);
  const {mode} = useDarkMode();
  const [updateMode, setUpdateMode] = useState(false);
  const [updatePasswordMode, setUpdatePasswordMode] = useState(false);
  const {navigate} = useNavigate();


  return (
    <Stack style={{maxWidth: '1000px'}} gap={5}>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{
          color: mode.settings.textColor3,
          paddingTop: 15,
          paddingBottom: 15,
          marginBottom: '-30px',
        }}>
        {[
          <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => navigate('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
          </Typography>,
          <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            style={{color: mode.settings.textColor3}}>
            Mon compte
          </Typography>,
        ]}
      </Breadcrumbs>
      {updateMode ? (
        <UpdateProfile setUpdateMode={setUpdateMode} />
      ) : (
        <ViewProfile setUpdateMode={setUpdateMode} />
      )}
      {updatePasswordMode ? (
        <ChangePassword setUpdatePasswordMode={setUpdatePasswordMode} />
      ) : (
        <ViewPassword setUpdatePasswordMode={setUpdatePasswordMode} />
      )}
      <NotificationConfig />
      <Associate />
    </Stack>
  );
};

export default withNavigation(Profile);
